// extracted by mini-css-extract-plugin
export default {"item":"Ba9fD"};